import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/crm/pipeline',
}).lazy(() => import('./pipeline.lazy').then((d) => d.Route))
